import forEach from 'lodash/forEach'

const assignColorsToCssVariables = colors => {
  const root = document.documentElement

  forEach(colors, (color, name) => {
    root.style.setProperty(`--color-${name}`, color)
  })

  if (typeof colors.primary !== 'undefined' && colors.primary) {
    root.style.setProperty(`--fa-primary-color`, colors.primary)
    root.style.setProperty(`--fa-primary-opacity`, '1.0')
    root.style.setProperty(`--fa-secondary-color`, colors.primary)
    root.style.setProperty(`--fa-secondary-opacity`, '.4')
  }
}

export {
  assignColorsToCssVariables,
}
